var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImportByFile',{attrs:{"title":_vm.$t('menu.import_clients'),"resource":_vm.$t('menu.clients'),"import_endpoint":"clients/import_file","csv_xlsx":true,"csv_model":"clients_upload.csv","xlsx_model":"clients_upload.xlsx"}})}
var staticRenderFns = []

export { render, staticRenderFns }